const variables = {
    en: {
        omniflix: 'OmniFlix',
        connect_heading: 'Create, Manage, Distribute & Monetize Media Assets',
        connect_sub_heading: 'Create tokenized assets & communities. Mint, manage, monitor both NFTs and tokens powering your community. OmniFlix is a decentralized media and network layer for Creators & Sovereign Communities powered by NFTs and related distribution protocols',
        connect_keplr: 'Connect with Keplr',
        what_is_keplr: 'What is Keplr?',
        keplr_connecting: 'Approve connection request on the Keplr window...',
        leap_connecting: 'Approve connection request on the Leap window...',
        keplr: 'Keplr',
        leap: 'Leap',
        cosmostation: 'Cosmostation',
        sign_in_web3_wallet: 'Sign In with your web3 Wallet',
        networks: 'Networks',

        // Nav Bar
        edit_profile: 'Edit Profile',
        settings: 'Settings',
        billing: 'Billing',
        disconnect: 'Disconnect',
        assets: 'Assets',
        communities: 'Communities',
        dashboard: 'Dashboard',
        asset_library: 'Asset Library',
        campaign: 'Campaign',
        version: 'Studio v1.0.1',
        interactive_videos: 'Interactive Videos',

        // Upload Assets
        create_assets_uploading_files: 'Create Assets by Uploading Files',
        click_to_upload: 'Click to Upload',
        drop_your_files_here: 'Drop your files here',
        or: 'OR',
        go_to_asset_library: 'Go to Asset Library',
        asset_uploaded_successfully: 'Asset uploaded successfully',
        asset_upload_stopped: 'Asset upload stopped',
        upload_in_queue: 'Upload in Queue',
        file_selected: 'File Selected',

        dashed_or: '-- OR --',
        select_the_source: 'Select the source',
        supported_formats: 'Supported file format: audio, image, video, application .doc, .docx, application, msword, application.',
        drop_an_asset_size_up_to_2GB: 'Drop an asset size up to 2GB',
        check_the_uploaded_files: 'Check the uploaded Files in asset library!',
        uploaded: 'Uploaded',
        failed: 'Failed',
        upload_failed: 'Upload failed',
        retry: 'Retry',

        // Welcome Page
        welcome_to_omniflix: 'Welcome to OmniFlix Studio!',
        home_page_sub_heading: 'Please choose any of the following',
        flix_studio: 'Assets',
        assets_management: 'mint, manage & monetize',
        flix_studio_content: 'Create, manage, distribute & publish media assets like NFTs containing videos, audio files, graphics/gifs & text for monetization with the help of your community!',
        flix_tribe: 'Communities',
        community_management: 'mint, manage & engage',
        flix_tribe_content: 'Create your community, manage it and engage community members with various activities and reward/incentivize them with NFTs & community tokens!',
        notifications: 'Notifications',
        show_all: 'Show all',

        // Create Assets
        create_assets: 'Create Assets',
        nft_collection: 'NFT Collection',
        collection_content: 'Denom is the denomination representing the collection of NFTs. You need to create atleast one denom to Mint your assets as NFTs. Create and mint denom/collection before minting your assets.',
        video: 'Video',
        video_content: 'Create and Mint video assets. You can even mint tweets as videos.',
        artwork: 'Artwork/Image NFT',
        artwork_content: 'Create and mint your artworks, gifs',
        audio: 'Audio NFT',
        audio_content: 'create and mint audio assets via soundcloud, YouTube, etc..',
        text_content: 'Create and mint text assets like articles, documents, etc..',
        interactive_video: 'Interactive Video NFT',
        interactive_content: 'Create an interactive video experience for consumers',
        new: 'New',
        coming_soon: 'Coming Soon',
        create_asset: 'Create Asset',
        asset_information: 'Asset Information',
        asset_info: 'Asset Info',
        mint_nft: 'Mint',
        list_nft: 'List NFT',
        add_interactions_button: 'Add interactions',
        nft_info: 'NFT Info',
        collection_Info: 'Collection Info',
        nft_no_info: 'Fill your asset metadata to mint NFT',
        publish: 'Publish',
        publish_on_tv: 'Publish on TV',
        enable_video_drop: 'Enable Video Mint',
        un_publish: 'Unpublish',
        listing: 'Listing',
        asset_title: 'Asset Title',
        suffix_start_count: 'Suffix start count',
        asset_title_info: 'Enter your asset title over here. If empty, filename or ID of the source will be taken as title',
        enter_asset_title: 'Enter Asset Title',
        asset_title_error: 'Asset Title should not be empty',
        asset_type: 'Asset Type',
        source_type: 'Source Type',
        source_type_info: 'Here you select the source type for the video. Currently, you can generate video of your tweet',
        select_source_type: '-- Select Source Type --',
        source_type_error: 'Source Type should not be empty',
        file_url: 'File URL',
        upload_file: 'Upload File',
        re_upload_file: 'Re-Upload File',
        upload_file_error: 'File should not be empty',
        upload_file_info: 'Drag ‘n’ Drop or Select file to upload',
        drag_and_drop: 'Drag and Drop Files over here',
        browse_files: 'Browse Files',
        browse_file: 'Browse File',
        uploading_files: 'Uploading files',
        uploaded_files: 'Uploaded files',
        quick_edit: 'Quick Edit',
        tweet_url: 'Tweet URL',
        tweet_id_or_url: 'Tweet ID or URL',
        tweet_id_or_url_info: 'Tweet should be posted from your Twitter account',
        tweet_id_error: 'Invalid Tweet ID or URL',
        enter_tweet_id_or_url: 'Enter Tweet ID or URL',
        category: 'Category',
        category_info: 'Start typing and hit enter to create a new category or choose a category from the list',
        select_category_info: '-- Select Category --',
        type_to_add_category: 'Type to add New Category',
        category_error: 'Category should not be empty',
        description: 'Description',
        description_info: 'Write down description for your asset over here. Can contain a maximum of 250 characters.',
        enter_description: 'Enter description',
        description_error: 'Description size should not exceed 256 characters',
        description_error_500: 'Description size should not exceed 500 characters',
        description_error_250: 'Description size should not exceed 250 characters',
        description_error_5000: 'Description size should not exceed 5000 characters',
        question_error_150: 'Question size should not exceed 150 charecters',
        invalid_vote_details: 'Invalid proposal details',
        invalid_validator_details: 'Invalid validator details',
        tags: 'Tags',
        tags_info: 'Choose tags related to the asset over here. You can also add new tags from here.',
        add_tags: 'Add Tags',
        add_asset_for_preview: 'Add asset for a preview',
        preview_source_file: 'PREVIEW SOURCE FILE EMPTY',
        video_encoding_incomplete: 'Asset encoding incomplete...',
        none: 'None',
        create_video_tweet: 'Create Video Tweet - Walkthrough Video',
        next: 'Next',
        collection: 'Collection',
        collection_info: 'Gives information about a specific collection',
        nft_avatar: 'NFT Image',
        nft_avatar_placeholder: 'Enter image URL',
        nft_avatar_info: 'Upload Album Art (1440x1440). Optional, but we recommend so that your audio stands out from the rest',
        schema_properties: 'Schema Properties for Collection',
        nft_traits_text: 'NFT Traits for this Collection',
        schema_properties_info: 'Enter NFT property values under this collection.',
        invalid: 'Invalid',
        select_collection: '-- Select collection --',
        type_to_add_collection: 'Type to Add Collection',
        mint_nft_recipient: 'Mint NFT directly to Recipient?',
        mint_nft_recipient_info: 'Toggle ON to enable Mint NFT directly onto a recipient',
        recipient_address: 'Recipient Address',
        recipient_address_info: 'Enter the account address starting with `omniflix1` to mint an NFT directly to their account',
        enter_recipient_address: 'Enter recipient address',
        transfer_status: 'Transferability',
        transfer_status_info: 'Enable to give the NFT owner, the ability to transfer the NFT between accounts',
        transfer_status_info1: 'Non-transferable NFTs can NOT be transferred or traded. Transferable are tradable.',
        extensible: 'Extensible',
        extensible_info: 'Extensible Info',
        extensible_info1: 'Enabled, it allows you to license your NFTs in the future',
        nsfw_name: 'NSFW',
        nsfw: 'NSFW (not safe for work)',
        nsfw_info: 'not safe for work info',
        nsfw_info1: 'Not Safe for Work is a flag to indicate inappropriate content.',
        royalty_share: 'Royalty Share',
        creators_royalty: 'Creators Royalty',
        royalty_share_info: 'Royalty percentage % is received for every trade.',
        enter_royalty_share: 'Enter Royalty Share',
        back: 'Back',
        save_and_exit: 'Save and Exit',
        status: 'Status',
        create_new_collection: 'Create New Collection',
        enter_collection_name: 'Enter Collection Name',
        enter_collection_symbol: 'Enter Collection Symbol',
        symbol_placeholder: 'Enter collection symbol (e.g., BTC, BAYC)',
        write_about_mint: 'Write about your Mint',
        mint_collection: 'MINT COLLECTION',
        approval_pending: 'APPROVAL PENDING',
        mint_nft_status1_heading1: 'Mint NFT is not enabled.',
        mint_nft_status1_heading2: 'You are required to fill the following fields in Asset Info:',
        mint_nft_status1_content2: 'Source File or ID',
        mint_nft_status2_heading1: 'You can Mint NFT after the',
        mint_nft_status2_heading2: 'is processed/encoded.',
        video_: 'Video',
        asset: 'Asset',
        mint_nft_status2_content11: 'Your',
        mint_nft_status2_content12: 'is being processed right now.',
        mint_nft_status2_content2: 'You can save your asset and comeback to Mint NFT later.',
        mint_nft_status3_heading1: 'Your',
        mint_nft_status3_heading2: 'has been processed. You can Mint your asset as an NFT now.',
        mint_nft_status4_heading: 'This asset is Minted as NFT.',
        nft_id: 'NFT ID',
        nft_id_info: 'NFT ID is an identifier that represents a single NFT',
        nft_url: 'NFT URL',
        nft_url_info: 'NFT URL is an identifier that links to an external page of a single NFT',
        collection_id: 'DENOM/COLLECTION ID',
        collection_id_info: 'Denom represents a denomination for a collection of NFTs',
        collection_url: 'Collection URL',
        congratulations: 'Congratulations!',
        congrats_sub_text1: 'Your collection is now minted and added to the network.',
        congrats_sub_text2: 'You can now mint your assets as NFTs under this collection.',
        collection_name: 'COLLECTION NAME',
        collection_name_info: 'Enter your collection name.',
        collection_symbol: 'COLLECTION SYMBOL',
        collection_symbol_info: 'Enter collection or denom Symbol. This will act as denom symbol.(min 3 characters)',
        nft_properties: 'NFT Properties',
        nft_properties_info: 'Enter NFT property values under this collection.',
        editable_properties: 'Editable properties',
        non_editable_properties: 'Non-editable properties',
        go_back_to_asset: 'GO BACK TO ASSET',
        done: 'Done',
        helping_text: 'Helping Text',
        collection_placeholder_description: 'Enter collection description over here',
        collection_json_schema: 'Enter your schema in JSON format',
        collection_description: 'Collection description',
        json_schema_properties: 'Schema Properties',
        json_schema_properties_info: 'Add Custom Schema, Upload Schema via JSON File or Choose from pre-defined schema templates. For Visual Editor, schemas with array properties can go upto one level only. Use code editor if you want to add more under  nested schema properties.',
        json_schema: 'JSON Schema',
        json_schema_info: 'Denom represents a denomination for a collection of NFTs',
        max_characters: '(Max: 250 characters)',
        image_url_placeholder: 'Enter image URL for Collection Avatar',
        collection_image_url: 'Image URL for collection avatar',
        required_field: '[required fields*]',
        upload_schema_json_file: 'Upload Schema via JSON File',
        publish_info: 'Publish Info',
        publish_no_info: 'Not Published. You need to mint your NFT to publish asset onto your own platform for streaming.',
        published_on: 'Published on',
        stream_url: 'Stream URL',
        selected_token: 'Selected Token',
        price: 'Price',
        selected_range: 'Selected Range',
        start_date: 'Start Date',
        end_date: 'End Date',
        start_time: 'Start Time',
        end_time: 'End Time',
        reserved: 'Reserved',
        enter_value: 'Enter Value',
        editable_properties_after_mint: 'Editable properties after Minting',
        face: 'Face',
        head: 'Head',
        eyes: 'Eyes',
        bling: 'Bling',
        publish_for_streaming: 'Publish for Streaming ',
        publish_for_streaming_info: 'Use this section to publish your NFTs onto your own OTT platforms powered by Blockchain.  More options to enable rental, subscription modes will be coming soon..',
        select_platforms_publish: 'Select platforms to publish',
        select_platforms_publish_info: 'Publish the NFT onto selected platforms for streaming',
        select_platform: 'Select Platform',
        enter_account_address_reserved_buyer: 'Enter account address for reserved buyer',
        fixed_price: 'Fixed Price',
        timed_auction: 'Timed Auction',
        choose_price: 'Choose Price',
        choose_price_info: 'If enabled, You can see your asset listed on nulceus market platform',
        schedule_listing: 'Schedule Listing',
        schedule_listing_info: 'Select Validity period for this listing. Select Start and End Date.',
        select_token: 'Select Token',
        select_token_error: 'Token should not be empty',
        enter_price: 'Enter Price',
        select_range: 'Select range',
        submit_listing: 'Submit Listing',
        select: 'Select',

        // Library
        all: 'All',
        drop_an_asset_size_up_to_1GB: 'Drop an asset size up to 1000MB',
        supported_formats_mn: 'Supported file format: video',
        delete_media_node_asset: 'Delete Media Node Asset',
        media_node_assets: 'Media Node Assets',
        non_minted_assets: 'Non-Minted Assets',
        nfts: 'NFTs',
        nft_details: 'NFT Details',
        listed: 'Listed',
        auctions: 'Auctions',
        collections: 'Collections',
        collection_details: 'Collection Details',
        asset_details: 'Asset Details',
        asset_details_info: 'write down some description over here about what this section has.',
        watch: 'Watch',
        edit: 'Edit',
        view: 'View',
        delete: 'Delete',
        title_qv: 'Title',
        twitter_id_url_qv: 'Twitter ID or URL',
        description_qv: 'Description',
        tags_qv: 'Tags',
        thumbnails_qv: 'Thumbnails',
        nft_id_qv: 'NFT ID',
        nft_link_qv: 'NFT link',
        nft_name: 'NFT Name',
        denom_name: 'Denom name',
        denom_symbol: 'Denom Symbol',
        denom_symbol_info: 'A DENOM represents a collection of NFTs',
        denom_description: 'Denom Description',
        helping_text_denom: 'A DENOM represents a collection of NFTs',
        denom_id: 'Denom ID',
        denom_id_info: 'Denom represents a denomination for a collection of NFTs',
        denom_preview_url: 'DENOM PREVIEW URL',
        denom_preview_url_info: 'Denom represents a denomination for a collection of NFTs',
        preview: 'Preview',
        edit_asset: 'Edit Asset',
        delete_asset: 'Delete Asset',
        delist: 'DeList',
        share: 'Share',
        transfer: 'Transfer',
        to: 'To',
        show_asset_info: 'Show Asset Info',
        burn_nft: 'Burn NFT',
        select_platform_to_share: 'Select the social platform to share asset',
        agree_to_delete: 'Do you agree to delete the NFT?',
        enter_last_characters: 'Enter last 4 characters of the NFT ID',
        are_you_sure_to_delete: 'Are you sure to delete this asset?',
        okay: 'Okay',
        asset_deleted: 'Asset Deleted',
        burn: 'Burn',
        cancel: 'Cancel',
        enter: 'Enter',
        confirm: 'Confirm',
        write_info: 'write down some description over here along with link for help',
        nft: 'NFT',
        total_nfts_in_collection: 'Total NFTs in Collection',
        total_nfts_owned: 'Total NFTs Owned',
        no_assets_available: 'No Assets Available',
        create_your_first_asset: 'Create your first ASSET NOW',
        list_price: 'List Price',
        auction_price: 'Auction Price',
        supports_ibc: '(supports IBC tokens too)',
        list_price_info: 'If listed, you should see this asset listed on the OmniFlix Marketplace',
        split_info: 'Split Info',
        split_info_info: 'Sum of all splits cannot exceed 100%',
        enter_split_address: 'Enter Account Address',
        enter_split_percentage: 'Enter split share %',
        create_listing: 'Create Listing',
        create_auction: 'Create Auction',
        sale_breakdown: 'Sale Breakdown',
        bulk_edit: 'Bulk Edit',
        bulk_actions: 'Bulk Actions',
        selected: 'assets selected',
        list_nft_s: 'List NFTs',
        de_list_nft_s: 'De-LIST NFTs',
        bulk_de_listing: 'Bulk DeList',
        bulk_listing_confirmation: 'Bulk NFT Listings Confirmation',
        bulk_de_listing_confirmation: 'Bulk NFT De-Listings Confirmation',
        burn_note: 'Enter last 4 characters of the Account address',

        // Dashboard
        active_account: 'Active Account',
        flix: 'FLIX',
        participate_in: 'Participate in',
        and_get_rewards: 'and get rewards',
        goto_campaign: 'Go to Campaign',
        create_video: 'Create Video',
        create_collection: 'Create Collection',
        update_collection: 'Update Collection',
        create_artwork: 'Create Artwork',
        create_interactive_video: 'Create Interactive Video',
        create_iv: 'Create IV',
        add_interactions: 'Add Interactions',
        create_audio: 'Create Audio',
        claim_tokens: 'Claim Tokens',
        asset_preview_not_ready: 'Asset preview not ready',
        no_nft_preview: 'No NFT preview',
        collection_preview_not_ready: 'Collection preview not ready',
        empty_collection: 'Empty collection',
        transferability: 'Transferability',

        // Campaign
        flixnet_campaign: 'FlixNet-2 Campaign',
        verify_twitter_account: 'Verify Twitter Account',
        verify_twitter_account_to_request: 'Verify Twitter Account To Request fee grant',
        verify_twitter: 'Verify Twitter',
        verify_twitter_info: 'Twitter verification is needed to Mint Tweet as NFTs. You can verify Twitter account from the account page.',
        verify_twitter_error: 'Twitter Account is not verified',
        verified: 'Verified',
        completed: 'Completed',
        create: 'Create',
        spread_the_word: 'Spread The Word (Optional)',
        screenshot_this_tweet: 'Screenshot this and tweet with',
        hash_tag_flixnet2: '#FlixNet2',
        mention_omniflix: '@OmniFlixNetwork',
        share_tweet: 'Share Tweet',
        share_tweet_info: 'Copy & Paste the below text and tweet from your account. You will have to enter the Tweet URL in next step',
        verify_tweet: 'Verify Tweet',
        enter_twitter_username: 'Enter your Twitter username',
        enter_tweet_url: 'Enter tweet URL for verification',
        submit: 'Submit',
        copy_text: 'Copy Text',
        twitter_verified: 'Your Twitter Account has been verified.',
        go_to_campaign_page: 'Go to Campaign page',
        camp_step1: 'Claim FLIX & other testnet tokens',
        camp_step1_info: 'Claim FLIX & native tokens such as SPAY & JUNOX. Deposit them into FlixNet-3 using IBC',
        camp_step2: 'Create Collection',
        camp_step2_info: 'To complete this task, create a collection of NFTs with or without Schema. Bonus points for creating collection with Schema.',
        camp_step3: 'Mint 3 NFTs - video, audio, image or even a document',
        camp_step3_info: 'To complete this task, Mint one Video NFT, one Audio NFT and one Image(or Document) NFT',
        camp_step4: 'List 2 NFTs in the Marketplace',
        camp_step4_info: 'To complete this task, List one NFT for sale with FLIX token and one NFT with a IBC Token (SPAY or JUNOX)',
        camp_step5: 'Goto OmniFlix Marketplace, Buy and Trade NFTs',
        camp_step5_info: 'To compete this task, Buy and Sell minimum of one NFT in marketplace with test tokens.',
        camp_step6: 'Transfer NFT to a friend  and invite to try OmniFlix Studio',
        camp_step6_info: 'To complete this task, Trasnfer an NFT to a friend or to community member. Optionally, share a screenshot of this page or any screen you like on social media and tag us',
        claim: 'claim',
        verify: 'Verify',

        // Account
        verify_social_account: 'Verify Social Account',
        verify_telegram: 'Verify Telegram',
        keplr_connected: 'Keplr Connected',
        account_activity: 'Account Activity',
        my_account: 'My Account',
        connected_with_keplr: 'Connected with Keplr',
        omniflix_network: 'OmniFlix Network',
        chain_id: 'FlixNet-3',
        recently_collected: 'Recently Collected',
        recently_minted: 'Recently Minted',
        recently_listed: 'Recently Listed',
        recent_activity: 'Recent Activity',
        see_all: 'See All',
        sent: 'Sent',
        change_profile_picture: 'Change Profile Picture',
        set: 'Set',
        as_profile_picture: 'as profile picture',
        choose_nft: 'Choose NFT',
        setting_profile_picture: 'Setting up your profile photo',
        takes_10_sec: 'This may take up to 10 secs',
        profile_photo_changed: 'Profile Photo changed successfully',
        pfp_something_went_wrong: 'Something went wrong!',
        pfp_try_again: 'Please try again.',
        pfp_drag_and_drop: 'or drag and drop',
        format_text: 'SVG, PNG, JPG or GIF (max. 800x800px)',
        format_text_thumbnail: 'PNG, JPG or GIF (max. 1920x1080px)',
        select_nft: 'Select NFT',

        // Listing Tab
        listing_info: 'Listing Info',
        listing_no_info: 'Not Listed. You need to mint your NFT to list for sale on Marketplaces/',
        listing_type: 'Listing type',
        listings: 'Listings',
        listings_info: 'Enter NFT property values under this collection.',
        listed_on: 'Listed on',
        owner: 'Owner',
        cancel_listing: 'Cancel Listing',
        close_window: 'Close Window',
        listing_on_marketplace: 'List on Marketplace',
        listing_on_marketplace_info: 'write down some description over here about what this section has.',
        listed_successfully: 'Listed Successfully',
        listed_successfully_info: 'Note: Listed NFT cannot be transferred.You can cancel listing for direct transfers.',
        listing_id: 'Listing ID',
        auction_id: 'Auction ID',
        listing_cancelled: 'Listing Cancelled',
        create_new_listing: 'Create New Listing',
        de_list: 'De List',
        total_sale_breakdown: 'Total Sale Breakdown',
        splits: 'Splits',
        market_place_share: 'Marketplace Share',
        selected_nft_s: 'Selected NFTs',
        nft_s: 'NFTs',
        transfer_selected_nft_s: 'Transfer Selected NFTs',
        transfer_note: '*Note: To transfer, enter recipient\'s Omniflix account address',

        // faucet
        faucet: 'FAUCET',
        connect_account: 'Connect Account',
        congrats: 'Congratulations!',
        claimed_tokens: 'You have claimed all your test tokens',
        deposit_ibc: 'Deposit via IBC',
        chain: 'Chain',
        claimed: 'Claimed',
        claim_test_tokens: 'Claim test Tokens',
        processing: 'Processing',

        deposit_ibc_asset: 'Deposit IBC Asset',
        ibc_transfer: 'IBC Transfer',
        from: 'From',
        amount_deposit: 'Amount to Deposit',
        available: 'Available',
        max: 'Max',
        deposit: 'Deposit',
        ibc_deposit_processing: 'IBC transaction successful, deposit processing...',
        channel_closed: 'Currently not accepting deposits from this channel',
        staking_successful: 'Staking successful',

        withdraw_ibc_asset: 'Withdraw IBC Asset',
        ibc_withdraw: 'IBC WithDraw',
        amount_withdraw: 'Amount to Withdraw',
        withdraw: 'Withdraw',
        ibc_tokens: 'IBC Tokens',

        // Collection Page
        primary_sales: 'Primary Sales',
        secondary_sales: 'Secondary Sales',
        non_listed: 'Non-Listed',
        floor_price: 'Floor Price',

        connect_to_us: 'Connect to us',
        omniflix_ecosystem: 'OmniFlix Ecosystem',
        stream_pay: 'Stream Pay',
        stream_pay_content: 'Create continous or delayed payment streams',
        try_app: 'Try the App',
        vote_us_on_devpost: 'Vote us on Devpost',
        studio_content: 'Mint, Manage & Monetize your NFTs',
        nucleus_content: 'Distribution platform for selling NFTs',
        insync_content: 'Communities tool to Stake, Vote, & more.. ',
        current: 'Current',
        try_now: 'Try Now',
        chain_using: 'Chains using InSync, OmniFlix for Communities',
        of_communities: '(stake, vote & more)',
        juno_content: 'smart contract network',
        cheqd_content: 'sovereign identity network',
        comdex_content: 'synthetic assets network',

        check_later: 'Transaction is in process. check after some time.',

        // filters
        filters: 'Filters',
        search: 'Search',
        price_range: 'Price Range',
        min_range: 'Min(00)',
        max_range: 'Min(50k)',
        on_sale_in: 'On-Sale In',

        // Create Collection
        collection_avatar: 'Collection Avatar',
        collection_avatar_info: 'Enter an IPFS URL of the collection avatar image or Upload from local directory',
        visual: 'Visual',
        code: 'Code',
        add_property: 'Add Property',
        enter_property_name: 'Enter Property Name',
        select_property_type: 'Select Property Type',
        required: 'Required',
        creation_fee: 'Creation Fee',

        split_shares: 'Split Shares',
        address: 'Address',
        weight: 'Weight',
        invalid_address: 'Invalid Address',
        invalid_account_address: 'Invalid account address entered',
        this_address_added: 'This address is already added',

        fee_grant_allowance: 'Fee Grant Allowance',
        fee_grant_content: 'Request for a fee grant allowance to collect, transfer, list & burn NFTs. FLIX tokens will not be visible in your account but your transaction fees will be paid by the app.',
        request_fee_grant: 'Request Fee Grant',
        allowance_received: 'Fee Allowance Received',
        allowance: 'Allowance',
        expiry: 'Expiry',
        fee_grant_expired: 'Fee Grant allowance Expired',
        mint_access_info: 'Reach out to the Flix Crew on Discord or fill the form for us to get back to you. You will receive special access to create/mint collections & NFTs.',
        mint_access_button: 'Request Access',
        collaborators_sum_warning: 'Collaborators sum should be equal to 100%',
        total_collaborators_breakdown: 'Total Collaborators Breakdown',
        collaborators_breakdown: 'Collaborators Breakdown',

        add_collaborators: 'Add Collaborators',
        share_percentage_of_royalties_text: 'Share a percentage of Royalties with contributors. Sum of all percentages can not be greater than 100%.',

        // confirm Dialog
        list_nft_confirmation: 'List NFT Confirmation',
        message_type: 'Message Type',
        listed_type: 'Listed Type',
        confirm_listing: 'Confirm Listing',
        confirm_auction: 'Confirm Auction',
        mint_collection_confirmation: 'Mint Collection Confirmation',
        update_collection_confirmation: 'Update Collection Confirmation',
        schema_property: 'Schema Properties',

        mint_nft_confirmation: 'Mint NFT Confirmation',
        confirm_mint_nft: 'Confirm Mint NFT',
        nft_image_url: 'NFT Image URL',
        royalties: 'Royalties',
        royalties_info: 'This % will be shared among creators',
        extensibility: 'Extensibility',
        schema: 'Schema',
        de_listing_nft_confirmation: 'De-Listing NFT Confirmation',
        auction_cancel_confirmation: 'Auction cancel Confirmation',
        confirm_de_listing: 'CONFIRM DE-LISTING',
        confirm_ibc_deposit_details: 'Confirm IBC Deposit Details',
        confirm_ibc_withdraw_details: 'Confirm IBC Withdraw Details',
        transfer_nft_confirmation: 'Transfer NFT Confirmation',
        confirm_transfer: 'Confirm Transfer',
        burn_nft_confirmation: 'Burn NFT Confirmation',
        confirm_burn: 'Confirm Burn',

        // create popover
        nft_collection_info: 'create a collection of NFTs',
        asset_via_upload: 'Asset via File Upload',
        asset_via_upload_info: 'create audio, video, document NFTs by uploading files',
        nft_via_file_upload: 'File upload',
        nft_via_file_upload_info: 'upload audio or video or images from your device',
        asset_from_other_source: 'Asset from Other Sources',
        asset_from_other_source_info: 'create NFTs from sources like twitter, YouTube, vimeo, soundcloud, etc...',
        create_interact_video: 'Interactive Video',
        create_interact_video_info: 'Create Interactive Video',
        broadcast: 'Broadcast',
        live_stream: 'Live Stream',
        poll: 'Poll',
        poll_info: 'create polls on NFT collections for your community',
        broadcast_content: 'Each channel supports only one live broadcast at a time.',

        something_went_wrong: 'Something went wrong',
        export: 'Export',

        // create poll
        create_poll: 'Create Poll',
        poll_collection_info: 'Select on which collection you want to create the poll',
        type_of_option: 'Type of option',
        type_of_option_info: 'Select Type of option',
        type_of_option_placeholder: '-- MCQ/POLL/QA --',
        poll_question: 'Poll Question',
        poll_question_info: 'write down poll question over here',
        poll_question_placeholder: 'Enter poll question',
        poll_description: 'Poll Description',
        poll_description_placeholder: 'Enter poll description over here',
        create_choices_for_poll: 'Create choices for poll',
        create_choices_for_poll_info: 'Select which NFT collection holders can vote on this poll',
        vote_access: 'Vote Access',
        vote_access_info: 'Select which NFT collection holders can vote on this poll. Enter the denom/collection IDs. You can find the collection ID in the\n' +
            'OmniFlix Market URL of the collection. Denom ID Example, onftdenom523e0f8fedghnshds91004916c426893',
        include: 'Include',
        include_info: 'lorem ipsum explanation',
        exclude: 'Exclude',
        add_denom_collection_id: 'Add Denom/Collection ID',
        enter_address: 'Enter Address',
        poll_duration: 'Poll Duration',
        poll_duration_info: 'lorem ipsum on schedule date',
        add_poll_choice: 'Add Poll Choice(10)',

        //    Export
        xlsx: 'xlsx',
        csv: 'csv',

        mint: 'Mint',
        min_bid_price: 'Min Bid Price',
        bid_increment_per: 'Bids Increment Percentage',
        whitelist: 'Whitelist',
        auction_start_time: 'Auction Start Time',
        auction_end_time: 'Auction End Time',
        optional: 'Optional',
        cancel_auction: 'Cancel Auction',
        bid_amount: 'BID Amount',
        auction_created_successfully: 'Auction Created Successfully',
        auction_cancelled_successfully: 'Auction Cancelled Successfully',

        // Interactive videos
        upcoming: 'Upcoming',
        active: 'Active',
        stats: 'Stats',
        ready_to_create_interactive_video: 'Ready to create an Interactive video?',
        drag_drop_video: 'Drag and Drop your video over here',
        edit_interaction: 'Edit Interaction',
        add_interaction: 'Add Interaction',
        add_iv_interaction: 'Start adding interactions',
        ways_add_interactions: 'Ways to add interactions',
        upload: 'Upload',
        add_answers: 'Add answers',
        save: 'Save',
        saved_interactions: 'Saved Interactions ',
        show_at: 'Show At',
        duration: 'Duration',
        edit_content: 'Tip: You can also hover and click below the timeline  to add interactions to the video',
        options: 'Options',
        option: 'Option',
        options_content: 'Note: Choose one right answer',
        image: 'Image',
        text: 'Text',
        url: 'URL',
        text_placeholder: 'NFT Name/Lore ipsum',
        add_option: 'Add Option',
        seek_to: 'Seek To',
        enter_timestamp: 'Enter Timestamp',
        no_videos_available: 'No Interactive Videos Available',
        create_your_first_video: 'Create your first Interactive Video NOW',
        no_videos_available_vod: 'No Videos Available',
        create_your_first_video_vod: 'Create your first Video NOW',
        duration_hours: 'Duration (In Hours)',
        publish_status: 'Publish Status',
        public: 'public',
        unlisted: 'Unlisted',
        private: 'Private',
        now: 'Now',
        schedule: 'Schedule',
        schedule_start_time: 'Schedule Start Time',
        select_add_interaction: 'Select type of interaction',
        cancel_esc: 'Cancel (ESC)',
        add_interaction_ways_info: '3 methods to integrate interaction points in your videos',
        maximum: 'Maximum',
        character_limit_exceeded: 'character limit exceeded',
        at_least_1940x1080_pixels: 'Max. size 5MB, GIF, JPEG or PNG',
        vtt_file: 'Upload .VTT file',
        published: 'Published',
        quiz_note: 'Note: Select the accurate answer by clicking',
        timestamp: 'Timestamp',
        validator: 'Validator',
        stake: 'Stake',
        single_select: 'Single Select',
        multi_select: 'Multiple Select',

        // vod
        continue_as_vod: 'Publish without Interactions',
        vod_sub_text: 'Ready to publish your video without interactions? Click Continue.',
        continue: 'Continue',
        vod: 'Video on demand',

        // publish
        please_select_channel: 'Please select the channel',
        create_new_channel: 'Create new channel',
        video_id: 'Video ID',
        video_name: 'Video Name',
        video_url: 'Video URL',
        interactions_added: 'Interactions added',
        scheduled_date: 'Scheduled Date',
        publish_settings: 'Publish settings',
        source_nft: 'Source NFT',
        source_nft_media: 'Source NFT Media',
        source_media: 'Source Media',

        created: 'Created',
        select_chain: 'Select chain',

        // Non minted
        bulk_mint: 'Bulk Mint',
        nft_title: 'NFT Title',
        suffix: 'Suffix',
        select_suffix: 'Select Suffix',
        suffix_info: 'Your NFT titles will look like ',
        suffix_count: 'Suffix start count',
        suffix_count_error: 'Suffix start count should not be empty',
        nft_description: 'NFT Description',
        accounts: 'Accounts',
        accounts_info: 'Enter/paste accounts to mint the NFTs to. Leave blank to mint NFT to yourself.',
        enter_url: 'Enter URL',
        nft_media_url: 'NFT Media URL',
        preview_url: 'Preview URL',
        add_addresses: 'Add Addresses',
        add_collections: 'Add Collections',
        add_collection: 'Add Collection',

        no_data_show: 'No data to show',
        sort_by: 'Sort By',
        export_activity: 'Export activity',
        overview: 'overview',
        interaction_id: 'Interaction ID',
        interactions: 'Interactions',
        publishing_info: 'Publishing Info',
        published_url: 'Published URL',
        publishing_platforms: 'Publishing Platforms',
        visibility: 'Visibility',
        whitelisted: 'Whitelisted',
        blacklisted: 'Blacklisted',
        video_visibility: 'Video Visibility',
        select_dynamic_network_config: 'Select dynamic network config',

        // Bulk mint
        mint_count: 'Mint count',
        single_nft: 'Single NFT',
        multiple_editions: 'Multiple Editions',
        mint_nft_to_recipient: 'Mint NFT to recipient',
        add_suffix: 'Add suffix to NFT Titles',
        suffix_note_heading: 'NFT Title will look like: ',
        suffix_note_content: 'Bored Ape #4, Bored Ape #5, Bored Ape #6',
        number_of_editions: 'Number of Editions to Mint',
        number_of_editions_place_holder: 'Enter number of editions to mint',
        whitelisted_placeholder: 'Paste recipient addresses over here (or) upload a CSV file in the right format',
        eligible_collections_placeholder: 'Paste collections over here (or) upload via CSV file...',
        upload_csv: 'Upload CSV',
        sample_csv: 'Sample CSV',
        invalid_file_format: 'Invalid file format',
        error_downloading_csv: 'Error downloading CSV',
        download_the: 'Download the',
        for_formatting_guidelines: 'for formatting guidelines',
        mint_directly_to_recipient: 'Mint NFTs directly to Recipient',
        disable: 'Disable',
        single_recipient: 'Single Recipient',
        multiple_recipient: 'Multiple Recipients',
        recipient_account: 'Recipient Account',
        recipient_accounts: 'Recipient Accounts',

        // ITC Module
        campaigns: 'Campaigns',
        create_campaign: 'Create Campaign',
        live: 'Live',
        search_by_title: 'Search by title',
        campaign_title: 'Campaign Title',
        description_itc: 'Write a brief and engaging description here',
        characters: 'Characters',
        schedule_campaign: 'Schedule Campaign',
        interaction_type: 'Interaction Type',
        verify_nft: 'verify NFT',
        transfer_nft: 'Transfer NFT',
        select_input_collection_interact: 'Select input Collections to interact',
        search_collection_paste_url: 'Search for collection to interact or paste collection URL',
        search_any_collection: 'Search for any collection',
        claim_type: 'Claim Type',
        deposit_tokens: 'Deposit Tokens',
        amount: 'Amount',
        amount_error: 'Amount should not be empty',
        tokens_per_claim: 'Tokens per claim',
        enter_tokens_per_claim: 'Enter Tokens per claim',
        tokens_per_claim_error: 'Tokens per claim should not be empty',
        max_allowed_claims: 'Max allowed claims',
        enter_count: 'Enter Count',

        instant: 'Instant',
        continuous_stream: 'Continuous Stream',
        delayed: 'Delayed',
        distribution_type: 'Distribution Type',

        setup_output_ft: 'Setup output FT (Fungible token)',
        setup_output_nft: 'Setup output NFT (Non-Fungible token)',

        source_file: 'Source File',
        upload_source_file: 'Upload source file',
        source_url_error: 'Source url should not be empty',
        preview_image: 'Preview Image',
        preview_url_error: 'Preview url should not be empty',
        enter_ipfs_url: 'Enter IPFs URL',
        enter_value_properties: 'Enter values for properties/traits for this NFT',
        enter_royalty_per: 'Enter royalty %',
        enter_title: 'Enter Title',
        start_date_error: 'Start Date is a mandatory field',
        end_date_error: 'End Date is a mandatory field',
        collection_error: 'Collection should not be empty',
        token_error: 'Token should not be empty',
        duration_in_seconds: 'Duration in Seconds',
        gated_until: 'Gated Until',
        gated_until_error: 'Gate Until is a mandatory field',
        gate_until_tooltip: 'Set time until video stays gated. The video becomes accessible by anyone after the specified time.',
        gate_until_tooltip_interactions: 'Set time until interactions in the video stay gated. The interactions are accessible by anyone after the specified time. ',

        title: 'Title',
        export_csv: 'Export CSV',
        campaign_info: 'Campaign Info',
        create_campaign_info: 'Distribute FTs, NFTs, or both, enabling actions like burning, verifying, or transferring NFTs.',
        interactive_type: 'Interactive Type',
        interactive_id: 'Interactive ID',
        starts_in: 'Starts In',
        ends_in: 'Ends In',
        stop: 'Stop',
        deposit_tokens_to_campaign: 'Deposit tokens to the campaign',
        confirm_stop_campaign: 'Confirm to stop campaign',
        curations: 'Curations',
        campaign_stopped: 'Campaign Stopped',

        title_tooltip: 'Enter a title that aptly captures your campaign.',
        description_tooltip: 'Write a concise summary that gives an overview of what your campaign is about.',
        scheduled_campaign_tooltip: 'Set the start and end times to define the duration of your campaign.',
        interaction_type_tooltip: 'Pick the user interaction you want to encourage (Verify, Transfer or Burn to claim).',
        select_collection_tooltip: 'Choose the NFT collection that users will interact using. ',
        claim_type_tooltip: 'Decide what users will receive after interacting - fungible tokens, NFTs, or both.',
        count_tooltip: 'Specify the maximum number of claims an account can make.',
        deposit_tokens_tooltip: 'Select the denom for claims, set the amount per claim, and the total amount of tokens for the campaign.',
        distribution_type_tooltip: 'Choose how rewards are sent - instantly in one transaction or continuously over time using the StreamPay module.',
        curation_fee: 'Fee',
        interaction_exists: 'Already interaction exists on same time',
        update: 'Update',

        // Overlay
        skip: 'Skip',
        write_down_ans_here: 'Write down your answer here...',
        overlay_header: 'Which video collection released in black sale period on OmniFlix Marketplace?',
        overlay_content: 'NOTE: This interaction is an on-chain transaction',

        // channels
        channels: 'Channels',
        channel: 'Channel',
        channelsv2: 'Channels v2',
        free: 'Free',
        pay_to_watch: 'Pay To watch',
        token_protected: 'Token protected',
        activity_gated_videos: 'Activity-gated Videos',
        sort_by_random: 'Sort By: Random',
        enter_user_name: 'Enter username',
        create_your_channel: 'Create your channel',
        user_name: 'Username',
        create_channel: 'Create Channel',
        channel_settings: 'Channel settings',
        general: 'General',
        storage: 'Storage',
        change_channel: 'Change channel',
        switch_channle: 'Switch Channel',
        edit_channel: 'Edit Channel',
        channel_name: 'Channel Name',
        enter_channel_name: 'Enter channel name',
        write_small_description: 'Write a small description',
        allow_others_publish: 'Allow others to publish',
        enter_account_number: 'Enter account address',
        create_your_channel_now: 'Create your first channel now!',
        re_upload: 're-upload',
        channel_details_updates: 'Channel Details Updated Successfully',
        per_subscription: 'Per subscription',
        subscribers: 'Subscribers',
        channel_description: 'Channel Description',
        asset_backup_coming_soon: 'Asset backup is coming soon..',
        keep_an_eye: 'Keep an 👀 on this space',
        channel_id: 'Channel ID:',
        creating_new_channel: 'Creating new channel',
        user_name_with_star: 'Username*',
        build_channel_own_content: 'Build Your Channel. Own Your Content.',
        create_channel_sub_text: 'OmniFlix gives you full control over your content. Claim your space now.',
        upload_channel_picture: 'Upload Channel Picture',
        upload_profile_sub_text: 'Your profile picture appears beside your videos, comments, and on your channel.',
        channel_profile_picture_format: 'GIF, PNG, JPG & SVG 1080 X 1080 px (max. 5 MB)',
        channel_banner_format: 'GIF, PNG, JPG & SVG 1390 X 480 px (max 10 MB)',
        upload_channel_cover: 'Upload Channel Cover',
        channel_banner_sub_text: 'Showcase your identity with a channel banner',
        channel_short_description: 'Write a short description about your channel...',
        collaborators: 'Collaborators',
        collaborators_sub_text: 'Royalties allow channel owners to receive a share of proceeds from the generated revenue',
        change: 'Change',
        channel_details: 'Channel Details',
        channel_branding: 'Channel Branding',
        collaborators_nd_royalties: 'Collaborators & Royalties',
        account_address: 'Account address',
        your_address: 'Your address',
        videos: 'Videos',
        playlists: 'Playlists',
        playout: 'Playout',
        videos_on_demand: 'Videos On Demand',
        interactive: 'Interactive',
        create_playlist: 'Create playlist',
        vote_on_proposal: 'Vote On Proposal',
        staking_interaction: 'Staking as Interaction',
        video_onDemand: 'Video On Demand',
        gated_interaction_until: 'Interactions Gated until ',
        gated_video: 'Gated Video',
        gated_video_until: 'Video Gated Until',
        streaming: 'Streaming',
        no_video_in_channel: 'No videos in this channel yet',
        no_video_in_channel_sub_text: 'Get started by publishing your first video to engage and grow your audience',
        no_streams: 'No streams yet',
        no_streams_sub_text: 'Start your first stream to go live and share your content with the world',
        channel_v1_not_supported: 'Channel V1 is no longer supported.',
        channel_v1_not_supported_sub_text: 'Migrate to Channel V2 to continue publishing videos.',
        discard_changes: 'Discard Changes?',
        unsaved_changes_text: 'You have unsaved changes. If you leave now, your edits will be lost.',
        discard: 'Discard',
        apply_changes: 'Apply Changes',

        // No Data
        upload_content: 'Upload Content',
        upload_content_sub_text: 'Record at home or on the go and upload your creations here. All your public content will be displayed in this section.',

        // IV Delete Dialog
        are_you_sure: 'Are you sure?',
        are_you_sure_delete: 'Are you sure? 🤔',
        delete_note: 'NOTE: This action can NOT be reversed or revoked and all associated data with the video is lost',
        deleted_successfully: 'Video deleted successfully',
        video_been_removed: 'Your video has been removed. To create a new interactive video, begin the process afresh.',
        delete_video_and_data: 'Delete Video & all associated data',
        view_all_videos: 'View all videos',

        // Unpublish dialog
        unpublish_success: 'Your video is now Unpublished',
        un_publish_video: 'Unpublish Video',
        unpublish_confirmation_text: 'Unpublishing will remove your video from the list of all the videos on the OmniFlix.tv app',
        edit_video: 'Edit Video',

        // Publish Dialog
        publish_success: 'Video published successfully',
        your_video_published: 'Your video is now published',

        // info
        asset_icon_info: 'Enter your Video details for display on OmniFlix.tv',
        optional_info: 'Set interaction as mandatory or optional for viewers',
        polls_icon_info: 'Create polls to engage viewers and gather their opinions',
        add_icon_info: 'Modify or Add interaction points to your video',

        blacklist_accounts: 'Blacklist Accounts',
        whitelist_accounts: 'Whitelist Accounts',
        eligible_collections: 'Eligible Collections',

        insufficient_content: 'Your current FLIX balance is too low for this transaction. Please swap tokens to increase your balance',
        insufficient_funds: 'Insufficient Funds',
        get_flix_now: 'Get FLIX now',

        // supported file details
        supported_file_format: 'Supported file format: audio, image, video, application .doc, .docx, application, msword, application.',
        file_size: 'Drop an asset size up to 5MB',
        file_size_exceeded: 'File size exceeds the 2GB limit, Please upload a smaller file',
        file_size_exceeded_4gb: 'File size exceeds the 4GB limit, Please upload a smaller file',

        enter_image_url: 'Enter Image URL here',
        non_transferable: 'Non Transferable',

        // video mints
        video_mints: 'Video Mints',
        video_mints_tooltip_text: 'Enter the required collection details and properties for a smooth setup of your Video Mints',
        please_enter_collection_name: 'Collection name for your Video Mints',
        complete_setup: 'Complete Setup',
        add_video_mint: 'Add Video Mint',
        choose: 'Choose',
        change_thumbnail: 'Change thumbnail',
        choose_video_to_setup_video_mint: 'Please choose a video to setup video mint',
        change_video: 'Change Video',
        mint_price: 'Price per mint',
        mint_price_tooltip_text: 'This is the price you want to charge for each mint. If you want it to be free, leave as 0 (zero).',
        max_mints_per_address: 'Max mints per address',
        total_supply: 'Total Supply',
        total_supply_tooltip_text: 'Set the total editions of your video available to mint',
        more_details: 'More Details',
        maximum_250_characters: 'Maximum 250 characters',
        symbol: 'Symbol',
        symbol_tooltip_text: 'Type the symbol you want to assign to this collection (ie: OFDROP).',
        thumbnail_tooltip_text: 'This is the preview image that will be shown for this Mints Collection.',
        nft_preview_url: 'NFT Preview URL',
        royalties_info_5: 'This 5% will be shared among creators',
        select_video: 'Select video',
        video_mint_created_successfully: 'Video Mints setup completed',
        view_explorer: 'View Explorer',
        publish_video_to_setup_video_mints: 'Publish a video to setup video mints',
        publish_video_info: 'Start off with minting your assets',
        publish_now: 'Publish Now',
        enable_mint_text: 'Interact to Mint',
        enable_mint_tooltip_text: 'If enabled, the MINT button is active/shown ONLY after participating in interactions',

        drop_collection_name: 'Collection name',
        drop_collection_name_tooltip_text: 'Automatically named after your channel',
        drop_collection_id: 'Collection ID',
        drop_collection_id_tooltip_text: 'This is the unique identifier for your Video Mint',
        collect_mint_revenue: 'Collect Mint Revenue',
        collect_mint_revenue_tooltip_text: 'Address where all earnings from minting Video Mints will be deposited',
        mint_per_address: 'Mint Per Address',
        mint_per_address_tooltip_text: 'Limit how many videos each address can mint',
        admin_address: 'Admin Address',
        admin_address_tooltip_text: 'This is the address that will be the administrator of the contract that manages the Mints.',
        enter_percentage: 'Enter percentage',
        drops_description_tooltip_text: 'Write a description that makes them eager to collect your Video NFT',

        nft_title_tooltip_text: 'Type the name you want for all the NFTs in this collection (it will have the index number #XX appended at the end automatically).',
        media_url_tooltip_text: 'Type the URL address or upload the NFT file (can be an image or a video).',
        preview_url_tooltip_text: 'Type the URL address or upload the preview of the NFT file (this is normally an image or a very short video).',

        price_per_flix: 'Price per FLIX',
        price_per_mint: 'Price per Mint',

        // drops dialog
        new_uploads: 'New uploads',
        token_gated: 'Token-gated',
        search_video: 'Search video',
        interactive_video_tab: 'Interactive Video',

        delete_video: 'Delete video',
        add_video: 'Add video',
        video_list: 'Video list',
        enable_video_mints: 'Enable Video mints on your videos',
        enable_video_mints_subtext: 'Select a video to enable video mints.',
        choose_video: 'Choose video',

        gated: 'Gated',
        gated_content: 'Gated Content',
        gate_content: 'Gate Content?',
        gated_interactions: 'Gated Interactions',
        gated_interactions_info_text: 'Please select a collection or whitelist Addresses to gate this Interactive Video.',
        search_for_collection: 'search for collection',
        csv_address_header: 'CSV header should contain "Address" to upload for whitelisted.',
        address_already_added: 'These addresses have already been added.',
        clear_all: 'Clear all',
        accounts_whitelisted: 'accounts whitelisted',
        account_whitelisted: 'account whitelisted',
        data_already_added: 'Data Already Added',
        no_data: 'No Data',
        accounts_in_file: 'accounts in this file',
        account_in_file: 'account in this file',

        video_mints_disconnected: 'Video mints disconnected!',
        disconnect_video_mints: 'Disconnect video mints',
        no_video_available: 'There is no video available!',
        upload_now: 'Upload now',
        instantiating_contract: 'Instantiating Contract',
        takes_time_text: 'This may take some time',
        setup_video_mints: 'Setup Video mints',
        setup_mints_sub_text: 'Customize your NFT collection, media, and mint details to launch the mint',
        set_up: 'Setup',

        // Open Edition Mint
        mint_limit: 'Mint Limit',
        mint_quantity: 'Mint Quantity',

        // Participation NFT
        video_drops: 'Video Drops',
        enter_total_units: 'Enter Total Units',
        total_units: 'Total Units',
        max_nfts_to_drop: 'Maximum NFTs to Drop',
        max_nfts_placeholder: 'e.g. 20',
        participated_nft_total_units_tooltip: 'Specify the total number of NFTs to be minted',
        initial_nft_index: 'Initial NFT Index',
        mint_index: 'Mint Index',
        enter_initial_nft_index_value: 'Enter Initial NFT Index Value',
        initial_nft_index_tooltip: 'Assign an index number for the first minted NFT',
        creator: 'Creator',
        name: 'Name',
        enter_name: 'Enter Name',
        name_placeholder: 'e.g. rainbow',
        description_placeholder: 'Write about your drop',
        participated_nft_name_tooltip: 'Add a title for your Drop NFTs',
        participated_nft_description_tooltip: 'Describe your Drop NFT briefly',
        participated_nft_royalty_tooltip: 'Define the royalty percentage for the NFT',
        tweet_text: 'Tweet Text',
        enter_tweet_text: 'Enter Tweet Text',
        tweet_text_placeholder: 'Write a twitter post here',
        view_tweet: 'View Tweet',
        twitter_post: 'Twitter post',
        view_sample: 'View sample',
        tweet_text_tooltip: 'Compose a tweet for users to share once their NFT is minted',
        counter: 'Counter',
        counter_tooltip_text: 'Set the starting serial number for this Drop NFT series',
        media_url: 'Media URL',
        participated_nft_select_collection: 'Select collection',
        select_collection_sub_text: 'Choose the existing collection',
        required_percentage: 'Required Percentage',
        required_percentage_tooltip: 'Specify the min. % of correct answers required to qualify for an NFT. Note: Answers to polls and governance proposals are automatically considered correct',
        enter_required_percentage: 'Enter Required Percentage',
        minted_until: 'End Time',
        minted_until_tooltip: 'Define when the Drop NFT minting for this video will end',
        nft_media_url_tooltip: 'IPFS URL for your NFT asset',
        nft_preview_url_tooltip: 'IPFS URL for your NFT preview image',
        static_data: 'Static NFT Metadata',
        dynamic_data: 'User Response NFT Metadata',
        participant_data: 'Tally NFT Metadata',
        enter_property_value: 'Enter Property Value',
        select_interaction: 'Select Interaction',
        static_data_tooltip_text: 'Define properties that remain constant.',
        dynamic_data_tooltip_text: 'Define properties captured from interactions as responses with in an interactive video.',
        participant_data_tooltip_text: 'Properties derived from user interactions.',

        // More Dialog
        details: 'Details',

        // Single Collection Tooltips
        contract_address: 'Contract address',
        contract_name: 'Contract name',
        created_on: 'Created on',
        paused: 'Paused',
        managed_by_contract: 'Managed by contract',
        owned_by_account: 'Owned by account',

        view_on_tv: 'View on OmniFlix TV',
        video_mint_setup_success: 'Collection for Video Mints created successfully. Configure the NFT for your first Video Mint below.',

        // Contracts
        contracts: 'Contracts',
        contracts_sub_text: 'Details of Video Mints contracts',
        download: 'Download',

        // Governance Proposals
        select_network: 'Select Network',
        select_proposal: 'Select Proposal',
        choose_proposal: 'Choose Governance proposal',
        voting_period: 'Voting period',
        voting: 'Voting',
        type: 'Type',
        no_active_proposals_available: 'No Active Proposals Available',
        loading: 'Loading...',
        proposal_optional_info: 'Governance Proposals are always optional',
        staking_optional_info: 'Staking is always optional',
        voting_ends_in: 'Voting ends in',
        voting_period_ended: 'Voting period ended',
        know_more: 'Know more on OmniFlix insync',

        // Live Stream
        add_your_ls: 'Add Your Live Stream',
        start_stream_today: 'Start your stream today',
        start_stream_today_info: 'Your media node is all set. Start streaming your content and share it with the world.',
        add_your_ls_content: 'Take control of your content delivery with a personal live streaming infrastructure. Setup takes less than 5 minutes, no technical expertise needed.',
        create_stream: 'Create Stream',

        // Lease
        lease_media_node: 'Lease Media Node',
        lease: 'Lease',
        lease_media_node_content: 'Monitor and Manage your Lease Media Node in the OmniFlix Network',
        register_media_node: 'Register Media Node',
        lease_register: 'Lease/Register',
        moniker: 'Moniker',
        storage_gb: 'Storage in GB',
        ram_gb: 'Ram in GB',
        contact: 'Contact',
        enter_contact: 'Enter Contact',
        price_per_hour: 'Price Per Hour',
        deposit_amount: 'Deposit Amount',
        enter_cpus: 'Enter CPUS',
        media_node_id: 'Media Node ID',
        my_leased_nodes: 'My Leased Nodes',
        my_leased_nodes_content: 'Start leasing with one of our providers',
        explore_nodes: 'Explore Nodes',

        // Media Nodes
        media_node: 'Media Node',
        media_node_content: 'Monitor and Manage your Media Node in the OmniFlix Network',
        add_your_mn: 'Add Your First Media Node',
        add_your_mn_content: 'Take control of your content delivery with a personal streaming infrastructure. Setup takes less than 5 minutes, no technical expertise needed.',
        add: 'Add',
        connect: 'Connect',
        new_node: 'New Node',
        add_new_node: 'Add new node',
        update_node: 'Update node',
        node_name: 'Node name',
        node_name_tooltip: 'Enter a name to your media node connection.',
        node_name_placeholder: 'Enter your node name',
        mn_media_url: 'Media IP/URL',
        url_tooltip: 'Media IP/ URL provided by your media node host.',
        url_disabled: 'Media IP/ URL field is disabled',
        mn_description_placeholder: 'Enter Description',
        auth_token: 'Auth token',
        auth_token_tooltip: 'Stream Key provided by the streaming platform',
        access_token: 'Upload access token',
        access_token_tooltip: 'Token required for content uploads provided by your Media Node host.',

        // Live Stream
        stream: 'Stream',
        program: 'Program',
        playlist: 'Playlist',
        adx: 'Adx',
        catalog: 'Catalog',
        media_node_information: 'Media Node Information',
        go_live: 'Go Live',
        restart: 'Restart',
        please_select_media_node: 'Please select the media node',
        please_select_visibility: 'Please select the visibility',
        clear_slot: 'Clear Slot',
        start: 'Start',
        stream_scheduled: 'This stream is Scheduled at',
        ready_to_go_live: 'Ready to Go Live?',
        ready_to_go_live_info: 'Start your first stream and bring your content to life. Once created, your live sessions will appear here for easy access and control',
        stream_now: 'Stream Now',
        ready_to_broadcast: 'Ready to broadcast?',
        ready_to_broadcast_info: 'Start your first broadcast and bring your content to life. Once created, your broadcast sessions will appear here for easy access and control',
        broadcast_now: 'Broadcast Now',

        // Staking
        select_validator: 'Select Validator',
        select_validator_continue: 'Select a validator to continue',
        min_stake: 'Minimum Stake',
        validator_stake: 'Validator to stake',

        // Create Contract Page
        creating_oem_contract: 'Creating OEM contract',
        collection_setup: 'Collection Setup',
        mint_configuration: 'Mint Configuration',
        updating_oem_contract: 'Updating OEM contract',
        creating_mmoem_contract: 'Creating MMOEM contract',

        // Collection Setup
        upload_avatar_info: 'Upload the collection avatar image from local directory',
        collection_name_p1: 'The name displayed all across the apps',
        description_info_p1: 'Write down description for your collection over here',
        add_collaborators_info: 'Share a percentage of Royalties with contributors. Sum of all percentages can not be greater than 100%.',
        collection_metadata: 'Collection Metadata',
        collection_metadata_info: 'Add a metadata via JSON, template, or custom input. Use the code editor for nested array properties beyond one level.',
        collection_description_field: 'Share a few words about your collection',
        or_drag_and_drop: 'or drag and drop',
        upload_info: 'SVG, PNG, JPG or GIF in 1:1 ratio (max. 20MB)',
        collection_symbol_1: 'Collection symbol',
        add_account: 'Add account +',

        // Mint Configuration
        nft_title_subtext: 'Provide a title for your NFT. This will help identify and display your NFT.',
        nft_title_placeholder_text: 'Enter Your NFT Title',
        description_subtext: 'Write down description for your asset over here',
        description_placeholder_text: 'Write your description here',
        admin_address_subtext: 'Specify the wallet with admin rights to manage the mint',
        address_placeholder: 'e.g., omniflix1...pa54htgwqpls5',
        payment_collector: 'Payment Collector Address',
        payment_collector_subtext: 'Enter the wallet address to receive mint payments',
        mint_per_address_subtext: 'Limit how many NFTs a wallet can mint',
        total_supply_subtext: 'Set the maximum number of NFTs available',
        start_time_subtext: 'Set the minting start and end time in UTC',
        start_end_time_subtext: 'Start* and end time',
        whitelist_subtext: 'Set up whitelist to allow only selected addresses to mint',
        price_per_mint_subtext: 'Set the price per NFT during the open edition sale',
        instantiated_oem_success: 'Successfully instantiated the OEM contract',
        updated_oem_success: 'Successfully updated the OEM contract',
        view_tx: 'View Tx',
        view_mint: 'View Mint',
        close: 'Close',
        whitelist_setup: 'Whitelist Setup',
        mint_admin: 'Mint Admin',
        mint_admin_info: 'Specify the wallet with admin rights to manage whitelist',
        upload_media: 'Upload Media*',
        upload_media_info: 'Select file to upload SVG, PNG, JPG, MP4 or GIF (max. 2GB)',
        past_media_url_here: 'Past your media URL here',
        round: 'Round',
        start_and_end_time: 'Start and end time',
        add_another_round: 'Add Another Round',
        whitelist_contract_created: 'Whitelist Contract Created Successfully',
        field_not_editable: 'Field is not editable',
        make_it_free: 'Make it Free',

        create_one_below: 'Please create one by clicking below',
        no_channel_found: 'No Channels found!',
        gate_with: 'Gate with',
        choose_gating: 'Choose the gating',
        gate_with_info: 'Chose the gating type you wish to implement',
        add_staking_preference: 'Add staking preference',
        network: 'Network',
        delete_staking_preferences: 'Are you sure you want to delete the staking preferences',
        validators: 'Validators',

        select_previous_contract: 'Select previous contract',
        created_at: 'Created At',
        select_contract: 'Select contract',
        select_contract_subtext: 'Select from the list of contracts created by you',
        remove: 'Remove',
        add_another_nft_edition: 'Add Another NFT Edition',
        select_network_info: 'We recommend enabling chains natively supported by OmniFlix TV for the best experience. Only users with addresses on enabled chains can participate, and creators can export participant addresses for engagement.',

        // Media Node Lease
        add_lease_hours: 'Add Lease Hours',
        lease_hours: 'Lease Hours',
        lease_hours_tooltip: 'Enter Lease Hours to your media node connection.',
        lease_hours_placeholder: 'Enter Lease Hours',
        extend_lease_hours: 'Extend Lease',

        // asset publish
        publish_to_channel_contract: 'Publish to Channel Contract',
        asset_publish: 'Asset Publish',

        select_role: 'Select Role',
        role: 'Role',
        remove_collaborators: 'Remove Collaborators',
        remove_collaborator_success: 'Successfully removed Collaborator',

        livestream_access_token: 'Livestream Access Token',
        add_destination: 'Add a Destination',
        manage_destinations: 'Manage Your Streaming Destinations',
        manage_destinations_info: 'Easily manage, organize, and add your uploaded videos to playlists',
        add_destinations: 'Add Destinations',
        edit_destinations: 'Edit Destinations',
        destinations: 'Destinations',
        oauth: 'OAuth',
        input: 'Input',
        saving: 'Saving',
        view_on_destination: 'View on destination',
        my_destinations: 'My Destinations',
        authorize_tv: 'Authorize OmniFlix TV',
        authorize_tv_info: 'Connect your channel to stream on your OmniFlix channel',
        video_thumbnail: 'Video Thumbnail',
        stream_ended_text: 'This stream has ended',
        remove_destination: 'Remove Destination?',
        remove_destination_sub_text: 'Removing a destination will immediately stop streaming to this Destination',

        // channel migration
        successfully_migrated: 'Successfully Migrated',
        migration_success_sub_text: 'All your content, profile, and NFTs are now secured under the new channel contract',
        migrating_your_channel: 'Migrating your Channel',
        in_queue_position: 'You\'re in queue position',
        starting_soon: 'Starting soon',
        migrate_text: 'Switch to the new Channels contract to manage your content more powerfully!',
        migrate_sub_text: 'Unlock full control with your V2 channel — grow your audience, build playlists, add banner, and manage roles effortlessly',
        migrate_now: 'Migrate Now',
        successfully_migrated_v2: 'Successfully Migrated to Channel V2',
        waiting_for_your_turn: 'You\'re in queue – waiting for your turn',
        retry_again: 'Please re-try again',
        migrate_without_worry: 'Migrate Without Worry',
        migrate_without_worry_sub_text: 'Your channel, content, and NFTs will move safely without data loss or interruptions',
        username: 'Username',
        display_name: 'Display Name',
        username_available: 'Username available',
        choose_another_username: 'Username already taken. Choose another',
        revoke_authorization: 'Revoke Authorization',
        revoke_authorization_info: 'Channel migration completed. You can safely revoke the link if it\'s no longer needed.',
        revoke: 'Revoke',
        share_on: 'Share on',

        // Para
        email: 'Email',
        connecting_para: 'Connecting to Para, this may take a few moments. Please be patient.',

        // Stream Page
        create_new_session: 'Create a new session',
        create_session_sub_text: 'Choose between a real-time or scheduled broadcast',
        stream_to_connected_destinations: 'Stream your content directly to connected destinations',
        broadcast_sub_text: 'Broadcast pre-recorded videos to live destinations',
        live_streams: 'Live Streams',
        broadcasts: 'Broadcasts',
        streams_and_broadcasts: 'Streams and Broadcasts',
        manage_live_nd_scheduled_sessions: 'Manage live and scheduled sessions.',
        stream_title: 'Stream Title',
        select_media_node: 'Select Media Node',
        ad_destination: 'Add Destination',
        select_destinations: 'Select Destinations',
        add_destination_sub_text: 'Select where your stream will be streamed. Add multiple destinations to go live across platforms',
        enter_a_description: 'Enter a description...',
        scheduled_for_later: 'Scheduled for later',
        enable_to_schedule_live: 'Enable this to set a date and time for your stream to go live.',
        no_destinations_yet: 'Looks like you don’t have any destinations yet!',
        no_destinations_yet_sub_text: 'No worries! You can add multiple destinations to start streaming across platforms',
        lease_node_text: 'Lease a Media Node to Start Streaming / Broadcasting',
        lease_node_text_info: 'Don’t have an active Media Node? Lease one to start broadcasting your content',
        go_live_info: 'It’s Time to Go Live and Share Your Moment',
        go_live_info_sub_text: 'Your stream is just a click away. Start engaging your audience in real-time or schedule a broadcast the choice is yours.',

        // privacy policy
        do_not: 'do not ',
        privacy_policy_agree: 'By continuing, you agree to our ',
        info_email: ' sistla@layerzerox.com',
        privacy_policy: 'Privacy Policy',
        effective_date: '14-June-2025',
        heading_1: '1) Introduction',
        heading_2: '2) Data We Collect',
        heading_3: '3) How We Use the Data',
        heading_4: '4) Storage and Security',
        heading_5: '5) Third-party Services',
        heading_6: '6) Your Rights',
        heading_7: '7) Updates',
        heading_8: '8) Children’s Privacy',
        heading_9: '9) Contact Us',

        text_1: 'This Privacy Policy explains how we handle your information when you use our app (the “App”). By using the App, you agree to the practices outlined here.',
        text_2: 'We use OAuth services (e.g., Google, YouTube, Apple, Discord) for secure sign-in and account linking. When you sign in, we may access the following basic information:',
        text_2_p1: 'Your name',
        text_2_p2: 'Email Address',
        text_2_p3: 'Profile picture (if available)',
        text_2_p4: 'Limited YouTube account information',

        text_3: 'We use the above data to:',
        text_3_p1: 'Authenticate your account and personalize your experience',
        text_3_p2: 'Allow you to set up and manage YouTube livestreams from within our App',
        text_3_p3: 'Connect your channel to our platform to enable relevant features',
        text_3_p4: 'Provide support for livestream-related issues',
        we_do_not: 'We do not:',
        text_3_p5: 'Sell your data',
        text_3_p6: 'Share your data with third parties without your consent',
        text_3_p7: '🔒 Note: Future updates may include features that request additional permissions (e.g., managing videos, accessing analytics). If implemented, we will update this policy and request your consent again.',

        text_4: 'We follow best practices to protect your data:',
        text_4_p1: 'Data is encrypted during transmission',
        text_4_p2_01: 'Only essential metadata is stored to enable streaming features',
        text_4_p2_02: 'You can revoke permissions anytime from your Google Account settings',
        text_4_p2_03: 'For deletion requests, contact us at',

        text_5: 'Our app interacts with third-party platforms like Google and YouTube via OAuth. These platforms have separate privacy policies, which we encourage you to review.',

        text_6: 'You may request to:',
        text_6_p1: 'View the data we have access to',
        text_6_p2: 'Delete your account and associated information',

        text_7: 'We may revise this Privacy Policy as we roll out new features. Any significant changes will be communicated via the app or email.',

        text_8_01_start: 'Our app is intended for use by content creators and is ',
        text_8_01_mid: 'not directed to children under the age of 13,',
        text_08_end: 'or the minimum legal age in your region (e.g., 16 in the EU).',
        text_8_02: 'We do not knowingly collect or solicit personal information from children.',
        text_8_03: 'If we become aware that we have unintentionally collected such data, we will take immediate steps to delete it.',
        text_8_04: 'If you believe a child has used our app and submitted personal information, please contact us at',

        text_9_01: 'If you have questions or concerns, contact us at:',

        for_youtube: 'YouTube OAuth Access',
        for_yotube_text: 'When you connect your YouTube account, we request limited access to the following data:',
        for_youtube_text_1: 'Your YouTube channel details',
        for_youtube_text_2: 'Your active/live broadcast details',
        for_youtube_text_3: 'Permission to manage your livestreams (e.g., creating, updating, ending live broadcasts)',
        we: 'We ',
        do_not_collect_01: 'access or store your passwords.',
        do_not_collect_02: 'access your video library, playlists, or analytics at this time.',
    },
};

export default variables;
